import React from 'react';
import { useAuth } from './AuthContext';
import './auth.css';

export default function AccessDenied() {
  const { user, logout } = useAuth();
  return (
    <div className="signal-auth-root" data-testid="access-denied-screen">
      <div className="signal-auth-bg" aria-hidden="true" />
      <div className="signal-auth-card">
        <div className="signal-auth-brand">
          <div className="signal-auth-mark signal-auth-mark-red" />
          <div className="signal-auth-brand-text">
            <div className="signal-auth-logo">ACCESS DENIED</div>
            <div className="signal-auth-tagline">ROLE NOT AUTHORIZED</div>
          </div>
        </div>
        <div className="signal-auth-title">{user?.email}</div>
        <div className="signal-auth-sub">
          Your account does not have <strong>Admin</strong> or <strong>Tech Support</strong> privileges on this control plane.
          Contact a SIGNAL administrator to have a role assigned.
        </div>
        <button className="signal-auth-submit" onClick={logout} data-testid="access-denied-signout-btn">
          SIGN OUT
        </button>
      </div>
    </div>
  );
}
